import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=3d1f3fae&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=ts&"
export * from "./Offers.vue?vue&type=script&lang=ts&"
import style0 from "./Offers.vue?vue&type=style&index=0&id=3d1f3fae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f3fae",
  null
  
)

export default component.exports